// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"content-module--contentStyles--3bE-5","emoji":"content-module--emoji--2-C7R"};